import apiClient from '../utils/apiClient';

export const login = async (email, password) => {
  try {
    const response = await apiClient.post('/identity/login', {
      eMail: email,
      password,
      rememberMe: false,
    });

    // Yanıtın içeriğini kontrol edin
    if (response.status === 200 && response.data?.accessToken) {
      const { accessToken, refreshToken } = response.data;

      // Başarılı yanıt
      return {
        success: true,
        data: { accessToken, refreshToken },
      };
    } else {
      // Beklenmeyen bir yanıt formatı
      return { success: false, message: 'Unexpected response format.' };
    }
  } catch (error) {
    console.error('Login error:', error);

    // Hata durumlarını kontrol edin
    if (error.response?.status === 401) {
      return { success: false, message: 'Invalid email or password.' };
    } else {
      return {
        success: false,
        message: 'An error occurred while trying to login.',
      };
    }
  }
};
export const getAllUsers = async () => {
  try {
    const response = await apiClient.get('/Identity/getAllUsers');

    if (response.status === 200 && Array.isArray(response.data)) {
      return response.data;
    } else {
      console.warn('Unexpected response format:', response);
      return [];
    }
  } catch (error) {
    console.error('Error fetching users:', error);
    throw new Error('An error occurred while fetching users.');
  }
};

export const getRoles = async () => {
  try {
    const response = await apiClient.get('/Identity/GetRoles');
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    return [];
  }
};

// KULLANICI KAYIT
export const registerUser = async userData => {
  try {
    const response = await apiClient.post('/Identity/register', userData);
    return response.data;
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
};

export const updateUser = async userData => {
  try {
    const response = await apiClient.put('/Identity/updateUser', userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

// export const getUserById = async userId => {
//   try {
//     const response = await apiClient.get(
//       `/api/Identity/GetUser?userId=${userId}`
//     );
//     return response.data;
//   } catch (error) {
//     console.error(
//       'Error fetching user:',
//       error.response?.status,
//       error.response?.data
//     );

//     if (error.response?.status === 404) {
//       return null; // Kullanıcı bulunamadı
//     }

//     throw new Error('An unexpected error occurred while fetching user.');
//   }
// };

export const getUserById = async userId => {
  try {
    const response = await apiClient.get(`/Identity/GetUser?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

export const deleteUser = async userId => {
  return await apiClient.delete(`/Identity/DeleteUser?userId=${userId}`);
};
export const changePassword = async (userId, currentPassword, newPassword) => {
  return await apiClient.put(`/Identity/ChangePassword`, null, {
    params: { userId, currentPassword, newPassword },
  });
};
